import { createColumnHelper } from "@tanstack/react-table";
import { getStatusBadge } from "../../component/table-utils/get-status-badge";
import React from "react";
import truncate from "../../lib/utils/truncate";
import TableMenu from "../../component/table-utils/tableMenu";
import formatDate from "../../lib/utils/formatDate";
import { CampaignDetails } from "../../lib/types";

export type OrdersDataType = {
  _id: string;
  campaign_name: string;
  assistant?: string;
  createdAt: string;
  campaign_description: string;
  is_paused: boolean;
  is_stopped: boolean;
  ai_agent_name: string;
  leads?: string;
};
const columnHelper = createColumnHelper<CampaignDetails>();

export const basicColumns = [
  columnHelper.display({
    id: "project",
    size: 250,
    header: "CAMPAIGN",
    cell: ({ row }) => <>{row.original.campaign_name}</>,
  }),
  columnHelper.display({
    id: "assistant",
    size: 120,
    header: "AGENT",
    cell: ({ row }) => <>{row.original.ai_agent_name}</>,
  }),
  columnHelper.display({
    id: "role",
    size: 120,
    header: "ROLE",
    cell: ({ row }) => <>{row.original.ai_agent_role}</>,
  }),

  columnHelper.display({
    id: "contacts",
    size: 110,
    header: "CONTACTS",
    cell: ({ row }) => <>{row.original.leadCount}</>,
  }),
  columnHelper.accessor("createdAt", {
    id: "dateCreated",
    size: 150,
    header: ({ column }) => (
      <div className="flex items-center gap-1">DATE CREATED</div>
    ),
    cell: (info) => <>{formatDate(info.getValue())}</>,
  }),
  columnHelper.display({
    id: "status",
    size: 110,
    header: "STATUS",
    cell: ({ row }) => {
      const status = row.original.is_completed
        ? "completed"
        : row.original.is_paused
        ? "paused"
        : row.original.is_stopped
        ? "stopped"
        : row.original.campaign_creation_percent_complete !== 100
        ? "in complete"
        : "active";
      return <>{getStatusBadge(status)}</>;
    },
  }),
  columnHelper.display({
    id: "actions",
    size: 30,
    cell: ({
      row,
      table: {
        options: { meta },
      },
    }) => (
      <div
        className="w-full flex justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <TableMenu row={row} page="projects" />
      </div>
    ),
  }),
];
